module.exports = __webpack_public_path__ + "img/raketa2.cab051c4.png";